import logo from '../assets/images/logo.png';
import InstagramIcon from './InstagramIcon';

export default function Footer() {
  return (
    <footer className="wrap">
      <div className="foot">
        <a href="#inicio" aria-label="Voltar ao início">
          <span className="logo">
            <img src={logo} alt="l’ora" />
          </span>
        </a>
        <small>&copy; 2026 l’ora &mdash; Conteúdo com direção.</small>
        <a
          href="https://www.instagram.com/lora.co_/"
          target="_blank"
          rel="noopener noreferrer"
          className="instagram-link"
        >
          <InstagramIcon />
          <span>@lora.co_ →</span>
        </a>
      </div>
    </footer>
  );
}
